import { isBoolean as n } from "./index32.js";
import { isEmpty as i } from "./index33.js";
import { isNill as f } from "./index36.js";
import { isString as e } from "./index40.js";
function E(s) {
  return m(s, 1);
}
function m(s, l) {
  const o = [];
  return e(s) ? s.trim().split(" ").forEach((a) => {
    const c = a.trim();
    !i(c) && o.push(c);
  }) : Array.isArray(s) ? l < 10 && s.forEach((r) => {
    const a = m(r, l + 1);
    !i(a) && o.push(a);
  }) : !f(s) && !n(s) && Object.keys(s).forEach((r) => {
    s[r] && r.trim().split(" ").forEach((c) => {
      const t = c.trim();
      !i(t) && o.push(t);
    });
  }), o.join(" ");
}
export {
  E as parseClassNames
};
